/* assets/ws-tracking.js (2026-10-09 PST). Loaded on every page by snippets/ws-tracking.liquid (rendered at the end of layout/theme.liquid).
   LAST UPDATED: 2026-10-09 PST - first version (tracking parity audit, docs/audit/TRACKING_PARITY.md).

   WHAT IT IS
   A small bridge. Two parts of this theme tell the page what the visitor did by sending a page event:
     "ws:intl"         the pop-up and the bar for visitors outside the United States (assets/ws-intl.js)
     "ws:save-prompt"  the "Want to pay less each day?" dialog on a product page (assets/ws-pdp-top.js)
   Before this file, nothing listened to those events. Both scripts also push an object into window.dataLayer, but on this store that list
   belongs to the Google tag of the Google & YouTube app, and the Google tag ignores plain objects (measured 2026-10-09 PST: the push
   happens, no request leaves the browser). So the events reached no analytics tool.
   The OLD theme did send three Google Analytics events from its international pop-up (snippets/international-popup.liquid, calls to gtag()).
   This file sends the same three names again, and one new event for each of the two parts.

   WHAT IT SENDS
   1. To Google Analytics 4, through window.gtag (the function the Google & YouTube app puts on the page):
        ws_intl          { ws_action: shown | click | close, ws_placement: popup | bar | product | cart, ws_country, ws_store: amazon | iherb, ws_via }
        ws_save_prompt   { ws_action: shown | subscribe | size_up | size_up_subscribe | decline, ws_product, ws_case: a | b | c }
        and, only for the pop-up, the names the old theme used, so reports that count them do not stop at the theme change:
        iherb_popup_shown      { event_category: 'International Popup', event_label: 'Popup Displayed' }
        iherb_popup_dismissed  { event_category: 'International Popup', event_label: 'Popup Closed' }
        iherb_click            { event_category: 'International Popup', event_label: 'Shop on iHerb' }   (a click on an iHerb button of the pop-up)
      Sent only when the visitor's privacy choice allows analytics (window.wsConsent, assets/ws-consent.js). When that helper is not ready, nothing is sent.
      When the Google app is removed from the store, window.gtag does not exist and nothing is sent: no error.
   2. To Shopify's customer events (Shopify.analytics.publish), as the custom events "ws_intl" and "ws_save_prompt" with the same values.
      A custom pixel (Shopify admin > Settings > Customer events) can read them with analytics.subscribe('ws_intl', ...). Shopify applies the
      visitor's privacy choice to each pixel by itself. Today no pixel reads them, so this part changes nothing until someone adds one.

   WHAT IT DOES NOT DO
   It does not send page views, product views, add to cart or checkout events. Shopify makes those by itself for every theme, and the ad
   pixels (Meta, Google, TikTok, Pinterest, Snapchat, Microsoft) get them from Shopify. Sending them here too would count each one two times.
   It reads no address parameter (utm_source, fbclid, gclid): Shopify, Meta, Google and Klaviyo store those by themselves (measured, same audit).

   FOR OTHER THEME CODE: window.wsTracking.send(name, params) sends one event the same two ways. window.wsTracking.log holds the last 50 (for tests).

   VERSION HISTORY: 2026-10-09 PST first version. */
(function () {
  'use strict';
  if (window.wsTracking) return;

  var log = [];

  function analyticsAllowed() {
    try {
      var s = window.wsConsent && typeof window.wsConsent.state === 'function' ? window.wsConsent.state() : null;
      return !!(s && s.ready === true && s.analytics === true);
    } catch (e) { return false; }
  }

  /* how: { ga: false } = do not send to Google Analytics; { shopify: false } = do not publish to Shopify's customer events. */
  function send(name, params, how) {
    var rec = { name: name, params: params || {}, ga: false, shopify: false };
    if (!(how && how.ga === false) && analyticsAllowed()) {
      try {
        if (typeof window.gtag === 'function') { window.gtag('event', name, rec.params); rec.ga = true; }
      } catch (e) { /* analytics must never break the page */ }
    }
    if (!(how && how.shopify === false)) {
      try {
        var a = window.Shopify && window.Shopify.analytics;
        if (a && typeof a.publish === 'function') { a.publish(name, rec.params); rec.shopify = true; }
      } catch (e) { /* ignore */ }
    }
    log.push(rec);
    if (log.length > 50) log.shift();
    return rec;
  }

  /* Visitors outside the United States: the pop-up, the bar, the note on a product page, the line in the cart. */
  document.addEventListener('ws:intl', function (e) {
    var d = (e && e.detail) || {};
    send('ws_intl', { ws_action: d.action || '', ws_placement: d.placement || '', ws_country: d.country || '', ws_store: d.store || '', ws_via: d.via || '' });
    /* The three names of the old theme. Google Analytics only: they exist so the old reports continue. */
    if (d.placement !== 'popup') return;
    var cat = 'International Popup';
    if (d.action === 'shown') send('iherb_popup_shown', { event_category: cat, event_label: 'Popup Displayed' }, { shopify: false });
    else if (d.action === 'close') send('iherb_popup_dismissed', { event_category: cat, event_label: 'Popup Closed' }, { shopify: false });
    else if (d.action === 'click' && d.store === 'iherb') send('iherb_click', { event_category: cat, event_label: 'Shop on iHerb' }, { shopify: false });
  });

  /* The save prompt of the product page. */
  document.addEventListener('ws:save-prompt', function (e) {
    var d = (e && e.detail) || {};
    send('ws_save_prompt', { ws_action: d.action || '', ws_product: d.product || '', ws_case: d['case'] || '' });
  });

  window.wsTracking = { send: send, log: log };
})();
